// extracted by mini-css-extract-plugin
module.exports = {"btnAsk":"pickupContainerManualScreen_btnAsk__dF4rn"};